import React, { useEffect, useRef, useState } from "react";
import { Button, Icon, Modal, Spin, notification } from "antd";

import { clientService } from "services";
import { displayErrorContext, validateProfileFields } from "utils";

import LabeledInput from "./_parts/LabeledInput";

const INITIAL_CLIENT = { __type: "Client", status: 1 };

const NewClientModal = ({ visible, onCancel, onCreated }) => {
  const [client, setClient] = useState(INITIAL_CLIENT);
  const [errors, setErrors] = useState({});
  const [uploading, setUploading] = useState(false);

  const mountedRef = useRef(true);
  useEffect(
    () => () => {
      mountedRef.current = false;
    },
    [],
  );

  const reset = () => {
    setClient(INITIAL_CLIENT);
    setErrors({});
  };

  const handleChange = (value, key) => {
    setClient((prev) => ({ ...prev, [key]: value }));
  };

  const handleCancel = () => {
    reset();
    onCancel();
  };

  const handleSubmit = () => {
    if (uploading) return;

    const { errors: validationErrors, hasError } = validateProfileFields(client, ["name"]);
    setErrors(validationErrors);
    if (hasError) return;

    setUploading(true);
    clientService
      .create(client)
      .then((created) => {
        if (!mountedRef.current) return;
        setUploading(false);
        reset();
        notification.open({
          message: "Client créé",
          description: `Le client « ${created.name} » a été créé et sélectionné.`,
          placement: "bottomRight",
        });
        onCreated(created);
      })
      .catch(() => {
        if (!mountedRef.current) return;
        setUploading(false);
        notification.open({
          message: "Une erreur s'est produite",
          description: "Impossible de créer le client. Veuillez réessayer.",
          placement: "bottomRight",
        });
      });
  };

  return (
    <Modal
      className="form-modal submission-new-client-modal"
      visible={visible}
      title={null}
      footer={null}
      onCancel={handleCancel}
      destroyOnClose
    >
      <h3>Nouveau client</h3>
      <Spin
        indicator={<Icon type="loading" spin style={{ fontSize: "52px" }} />}
        spinning={uploading}
      >
        <LabeledInput
          name="name"
          label="Nom"
          required
          value={client.name}
          error={errors.name}
          onChange={(v) => handleChange(v, "name")}
        />
        <LabeledInput
          name="address"
          label="Adresse"
          value={client.address}
          onChange={(v) => handleChange(v, "address")}
        />
        <LabeledInput
          name="zipcode"
          label="Code postal"
          value={client.zipcode}
          onChange={(v) => handleChange(v, "zipcode")}
        />
        <LabeledInput
          name="city"
          label="Ville"
          value={client.city}
          onChange={(v) => handleChange(v, "city")}
        />
        <LabeledInput
          name="tel"
          label="Téléphone"
          value={client.tel}
          onChange={(v) => handleChange(v, "tel")}
        />
        <LabeledInput
          name="contact_name"
          label="Nom du contact"
          value={client.contact_name}
          onChange={(v) => handleChange(v, "contact_name")}
        />

        {displayErrorContext(errors)}

        <div className="buttons">
          <Button type="link" onClick={handleCancel}>
            Annuler
          </Button>
          <Button type="primary" onClick={handleSubmit} loading={uploading} disabled={uploading}>
            Créer le client
          </Button>
        </div>
      </Spin>
    </Modal>
  );
};

export default NewClientModal;
